import NavLink from 'next/link';

import useRoutePaths from '@/src/hooks/useRoutePaths';
import {useTheme} from '@/src/hooks/useTheme';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Text} from '@/src/ui';

import css from '../styles/WikiHowLink.module.css';

const WikiHowLink = () => {
  const {HOW_T0} = useRoutePaths();
  const {isDarkMode} = useTheme();

  return (
    <div className={css.main}>
      <NavLink href={HOW_T0.path}>
        <a className={css.howToLink} aria-label={'link how to page'}>
          <img
            src={
              isDarkMode
                ? '/icons/wikiHowIconWhite.svg'
                : '/icons/wikiHowIcon.svg'
            }
            loading="lazy"
            alt="how to icon"
          />{' '}
          <span className={css.textLink}>
            <Text
              tagComponent={Text.TAG.SPAN}
              fontSize={Text.FONT_SIZE.SIZE_12}
              fontWeight={Text.FONT_WEIGHT.BOLD}
              color={isDarkMode ? Text.COLOR.WHITE : Text.COLOR.GRADIENT}
            >
              <TextLocal id={'wiki-how.title'} />
            </Text>
          </span>
        </a>
      </NavLink>
    </div>
  );
};

export default WikiHowLink;
